module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/large.64f02a95b821c5af3e80.jpg";